import http from "@/common/http.service";
const ROOT_URL = "mc-templates/lists";
export default {
  fetchItems(params, cb) {
    http.post(ROOT_URL, params).then(function (response) {
      var data = { items: response.data.data, total: response.data.total };
      cb(data);
    });
  },
  statusChange(params, cb) {
    return http.post("mc-templates/change-status", params);
  },
};
